import React from 'react';
import { Button, Form, Field } from '@cordata/buffet';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import * as Yup from 'yup';
import PropTypes from 'prop-types';

import {
  useApi,
  toastSuccess,
  toastError,
} from '~/utils';

const Fields = ({ appUser, afterSubmit }) => {
  const { api } = useApi();

  const initialValues = {
    newPassword: undefined,
    passwordResetRequired: true,
  };

  const validationSchema = Yup.object().shape({
    newPassword: Yup.string().min(8).required(),
    passwordResetRequired: Yup.boolean(),
  });

  const handleSubmit = (values, { setSubmitting }) =>
    api
      .put(`/app-user/${appUser.id}/change-password`, values)
      .then(() => {
        toastSuccess();
        setSubmitting(false);
        afterSubmit();
      })
      .catch(toastError);

  return (
    <Form
      displayName="ChangePassword"

      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <>
          <ModalBody>
            <Field
              name="newPassword"
              type="password"
            />

            <Field
              name="passwordResetRequired"
              type="checkbox"
              placeholder="Yes"
              disabled={appUser.authenticationService !== 'cordata'}
            />
          </ModalBody>

          <ModalFooter>
            <Button outline color="tertiary" type="cancel" onClick={afterSubmit}>
              Cancel
            </Button>

            <Button type="submit" disabled={isSubmitting}>
              Change Password
            </Button>
          </ModalFooter>
        </>
      )}
    </Form>
  );
};

Fields.propTypes = {
  appUser: PropTypes.shape().isRequired,
  afterSubmit: PropTypes.func.isRequired,
};

const ChangePasswordForm = ({ appUser, isOpen, toggle }) => (
  <Modal isOpen={isOpen} toggle={toggle}>
    <ModalHeader>Change Password</ModalHeader>

    <Fields appUser={appUser} afterSubmit={toggle} />
  </Modal>

);

ChangePasswordForm.propTypes = {
  appUser: PropTypes.shape().isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default ChangePasswordForm;
